import { useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    Stack,
    TextField,
} from '@mui/material';
import useErrors from '../../../../hooks/useErrors';
import server from '../../../../services/server';
import { EUROBEM_ADMIN_TEAMS } from '../adminTeams';

const schema = yup.object().shape({
    team: yup.string().oneOf(EUROBEM_ADMIN_TEAMS.map(t => t.value)).required('Selecione o cargo'),
});

export default function DialogChangeUserTeam({ open, user, onClose, onSuccess }) {
    const { setErrors, enqueueSnackbar } = useErrors();
    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: schema,
        initialValues: { team: user?.team || 'member' },
        onSubmit: async values => {
            if (!user?.id) return;
            try {
                await server.put(`users/${user.id}`, { team: values.team });
                enqueueSnackbar('Cargo atualizado.', { variant: 'success' });
                await onSuccess();
                onClose();
            } catch (error) {
                setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (open) formik.resetForm({ values: { team: user?.team || 'member' } });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, user?.id, user?.team]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Alterar cargo</DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2} pt={1} component="form" onSubmit={formik.handleSubmit}>
                    <TextField label="E-mail" value={user?.userName || ''} fullWidth disabled />
                    <TextField
                        select
                        label="Cargo"
                        name="team"
                        value={formik.values.team}
                        onChange={formik.handleChange}
                        fullWidth
                        error={formik.touched.team && Boolean(formik.errors.team)}
                        helperText={formik.touched.team && formik.errors.team}
                    >
                        {EUROBEM_ADMIN_TEAMS.map(item => (
                            <MenuItem key={item.value} value={item.value}>
                                {item.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button
                    variant="contained"
                    onClick={formik.handleSubmit}
                    disabled={formik.isSubmitting}
                >
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
